var take = /*#__PURE__*/require('../take');

function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
}
module.exports = dropLast;


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/ramda/src/internal/_dropLast.js
// module id = 1857
// module chunks = 0